import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 *  Changes an advance's status (approved or rejected)
 *
 * @param  payload
 * @return {Array} Advance's info
 */

const changeStatusAdvance = (payload, props = '') =>
  Vue.$http.put(`purchase/approved/advances/${props}`, payload)
    .then()
    .catch((err) => {
      throw err
    })

export default changeStatusAdvance


// WEBPACK FOOTER //
// ./src/services/purchase/advance/changeStatusAdvance.js